import { render, staticRenderFns } from "./ShowImg.vue?vue&type=template&id=42a3c0b7&"
import script from "./ShowImg.vue?vue&type=script&lang=ts&"
export * from "./ShowImg.vue?vue&type=script&lang=ts&"
import style0 from "./ShowImg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports